import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Eye } from 'lucide-react';
const VIEWER_SEQUENCE = [15, 16, 18, 20, 15];
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 24,
    seconds: 23
  });
  const [viewerIndex, setViewerIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const viewerTimer = setInterval(() => {
      setViewerIndex(prev => (prev + 1) % VIEWER_SEQUENCE.length);
    }, 3500);
    return () => clearInterval(viewerTimer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const viewers = VIEWER_SEQUENCE[viewerIndex];
  return <section className="py-6 md:py-14 px-4" data-id="element-16">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-xl mx-auto bg-slate-900 rounded-[2rem] p-5 md:p-8 text-center shadow-2xl border border-white/5" data-id="element-17">
        <div className="flex items-center justify-center gap-2 mb-3" data-id="element-18">
          <span className="text-xl md:text-2xl" data-id="element-19">⏰</span>
          <h2 className="text-lg md:text-2xl font-black text-white uppercase tracking-tight leading-tight" data-id="element-20">
            EL PRECIO PROMOCIONAL TERMINA EN:
          </h2>
        </div>

        <div className="flex justify-center items-center gap-3 md:gap-6 mb-5" data-id="element-21">
          <div className="flex flex-col" data-id="element-22">
            <span className="text-4xl md:text-5xl font-black text-rose-500 tabular-nums" data-id="element-23">
              {formatNumber(timeLeft.hours)}
            </span>
            <span className="text-[9px] md:text-[10px] font-bold text-slate-500 uppercase mt-1" data-id="element-24">
              HS
            </span>
          </div>
          <span className="text-3xl md:text-4xl font-black text-white/20 mb-4" data-id="element-25">
            :
          </span>
          <div className="flex flex-col" data-id="element-26">
            <span className="text-4xl md:text-5xl font-black text-rose-500 tabular-nums" data-id="element-27">
              {formatNumber(timeLeft.minutes)}
            </span>
            <span className="text-[9px] md:text-[10px] font-bold text-slate-500 uppercase mt-1" data-id="element-28">
              MIN
            </span>
          </div>
          <span className="text-3xl md:text-4xl font-black text-white/20 mb-4" data-id="element-29">
            :
          </span>
          <div className="flex flex-col" data-id="element-30">
            <span className="text-4xl md:text-5xl font-black text-rose-500 tabular-nums" data-id="element-31">
              {formatNumber(timeLeft.seconds)}
            </span>
            <span className="text-[9px] md:text-[10px] font-bold text-slate-500 uppercase mt-1" data-id="element-32">
              SEG
            </span>
          </div>
        </div>

        <p className="text-base md:text-lg font-bold text-white mb-6" data-id="element-33">
          El precio especial de <span className="text-rose-500" data-id="element-34">USD 14.99</span>{' '}
          estará disponible por tiempo limitado.
        </p>

        <div className="max-w-md mx-auto" data-id="element-35">
          <div className="flex justify-between items-end mb-2" data-id="element-36">
            <div className="flex items-center gap-2" data-id="element-37">
              <div className="w-2 h-2 bg-rose-500 rounded-full animate-pulse" data-id="element-38" />
              <span className="text-[10px] md:text-xs font-bold text-slate-400 uppercase tracking-wider" data-id="element-39">
                Precio especial de lanzamiento
              </span>
            </div>
            <span className="text-[10px] md:text-xs font-black text-white uppercase" data-id="element-40">
              Disponible por tiempo limitado
            </span>
          </div>

          <div className="h-2.5 bg-white/10 rounded-full overflow-hidden mb-2" data-id="element-41">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full bg-gradient-to-r from-rose-600 to-orange-500 rounded-full" data-id="element-42" />
          </div>
          <p className="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-3" data-id="element-43">
            Oferta promocional activa
          </p>

          <div className="flex items-center justify-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2" data-id="element-44">
            <Eye size={14} className="text-emerald-400 shrink-0" data-id="element-45" />
            <p className="text-[11px] md:text-xs font-bold text-slate-300" data-id="element-46">
              <motion.span key={viewers} initial={{
              opacity: 0,
              y: -4
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.3
            }} className="text-emerald-400 font-black tabular-nums" data-id="element-47">
                {viewers}
              </motion.span>{' '}
              personas están viendo esta página ahora
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}